module.exports = __webpack_public_path__ + "media/metronic/_theme/media/envato/screen2-b55f92c44bb9603dca42708b19b5d19d.jpg";